<div id="academy-courses" class="page-layout simple support">
    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center" style="width: 100%;">

        <div fxLayout="row" fxLayoutAlign="center" class="hero-text" style="width: 100%;">
          <ng-container *ngIf="landingPrincipal">
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" >
                {{landingTit | translate}}
            </h1>
          </ng-container>

          <ng-container *ngIf="!landingPrincipal">
            <button mat-icon-button class="mr-16" (click)="regresar()">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                {{'WIZARD.LANDING.PRODUCTO.GUIA.TITULO' | translate}}
            </h1>
          </ng-container>

        </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT -->
    <div class="content p-24">

    <ng-container *ngIf="landingPrincipal">

      <div fxLayout="row" fxLayoutAlign="space-between start" fxFlex="100">
          <div class="courses" fxLayout="row " fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
              <ng-container *ngIf="cargando">
                  <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <div fxLayout="column" fxLayoutAlign="space-between center">
                          <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                          <h2>{{'WIZARD.LANDING.PRODUCTO.GUIA.CHAN_INF' | translate}}</h2>
                      </div>
                  </div>
              </ng-container>

              <ng-container *ngIf="!cargando">


                      <div class="" fxLayout="column">

                          <ng-container *ngIf="productosAsignados.length == 0">
                              <div class="statusDiv" fxFlex="100" fxFlex.gt-sm="50" fxLayout="column" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                  <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                                      <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
                                      <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                                  </div>
                              </div>
                          </ng-container>

                          <ng-container *ngIf="productosAsignados.length > 0">
                              <div fxLayout="row wrap" fxLayoutAlign="space-around start" fxFlex="100" >
                                  <div *ngFor="let producto of productosAsignados; let i = index; let last = last; let first = first;" class="course" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}" >
                                      <div class="cursoCard" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}" fxFlex="100">
                                          <div class="course-content" fxLayout="column">
                                              <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                                                  <!-- <div *ngIf="producto.completo != 1" class="length" fxLayout="row" fxLayoutAlign="end center">
                                                      <mat-icon class="length-icon s-30">check_circle_outline</mat-icon>
                                                  </div> -->
                                              </div>

                                              <div class="content p-20 m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                                                  <div class="h1">{{producto.nombreProducto | translate}}</div>
                                                  <div class="updated">{{'WIZARD.LANDING.PRODUCTO.GUIA.NOM35.DONE' | translate}}{{producto.fechaNorma35}}</div>
                                              </div>
                                              <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                                                  <!-- <button mat-button class="accent rndBt" fxFlex="100" (click)="selectProduNorm('/'+producto.url,producto.productoID,producto.date,producto.instituto);">{{'WIZARD.LANDING.PRODUCTO.GUIA.NOM35.ENTRAR' | translate}}</button> -->
                                                  <button mat-button class="accent rndBt" fxFlex="100" (click)="selectProduNorm(producto);">{{'WIZARD.LANDING.PRODUCTO.GUIA.NOM35.ENTRAR' | translate}}</button>
                                              </div>



                                          </div>
                                      </div>

                                  </div>
                              </div>
                          </ng-container>
                      </div>
                  </ng-container>


          </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!landingPrincipal">
        <ng-container *ngIf="estadocentros">
          <div class="" fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 10px;" fxLayout.xs="column">
            <div class="category" fxFlex style="color: black; text-align: center; font-size: 22px;">{{ 'WIZARD.LANDING.PRODUCTO.GUIA.CT_NAME' | translate}} {{centroName}} </div>
          </div>
        </ng-container>

        <div fxLayout="row" fxLayoutAlign="center" fxLayout.xs="column">
          <div class="row center" fxFlex="100">
            <div class="col-sm-8 center" fxFlex="100" style="margin-left: 3%">
              <ng-container *ngFor="let producto of productos">
                <div *ngIf="producto.visible" style="margin-right: 4px;" class="cursoCard" fxFlex="100" [ngClass]="producto.category" [@animate]="{value:'*',params:{y:'100%'}}">
                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto" fxLayout.xs="column">

                    <div class="header primary" fxLayout="row" fxLayoutAlign="center center">
                      <div class="category" fxFlex style="color: white; text-align: center;">{{ producto.title | translate}}</div>
                    </div>
                    <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                      <div class="h1"></div><br>
                      <div class="h1_text">{{producto.descripcion | translate}}</div>
                    </div>

                    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                      <button mat-button class="accent rndBt" fxFlex="100" [routerLink]="producto.slug">{{ 'WIZARD.LANDING.PRODUCTO.GUIA.BUTTON' | translate}} </button>
                    </div>


                  </div>
                </div>
              </ng-container>
              <div class="no-courses" *ngIf="productos.length === 0">
                No courses found!
              </div>

            </div>
          </div>
        </div>
    </ng-container>
  </div>
    <!-- / CONTENT -->
</div>
